import React from "react";
import { useParams, Navigate } from "react-router-dom";

const ValidateBusinessUrl = ({ children }) => {
  const { businessUrl } = useParams(); 

  // If valid, render the component; otherwise, redirect or show an error message
  return businessUrl ? (
    children
  ) : (
    <Navigate to="/error" /> // Replace with your error component or page
  );
};

export default ValidateBusinessUrl;
